import {
  ANALYTICS_DELTA_BEHAVIORS,
  ANALYTICS_METRIC_SEMANTICS,
  ANALYTICS_SUMMARY_BEHAVIORS,
  ANALYTICS_TIME_BEHAVIORS,
  ANALYTICS_VISUAL_TYPES,
  createAnalyticsLibraryCategory,
  createAnalyticsLibraryEntry,
  createAnalyticsSectionLibrary
} from '../../visuals/visualDataModel';
import { ANALYTICS_GRAPH_TYPES } from '../../visuals/graphCatalog';
import { ANALYTICS_GROUP_BY_KEYS } from '../../analyticsFilters';

const semantics = (metric, time, summary, delta = ANALYTICS_DELTA_BEHAVIORS.NONE) => ({
  metric,
  time,
  summary,
  delta
});

const SCREEN_FILTERS = [];

const pipelineRiskAnalyticsLibrary = createAnalyticsSectionLibrary({
  section: 'pipeline_risk',
  categories: [
    createAnalyticsLibraryCategory({
      id: 'pipeline_risk_core',
      label: 'Pipeline & Risk',
      widgets: [
        createAnalyticsLibraryEntry({
          id: 'open_roles_risk',
          label: 'Open Roles & Risk',
          category: 'pipeline_risk_core',
          visualType: ANALYTICS_VISUAL_TYPES.COMPARISON,
          supportedGraphs: [ANALYTICS_GRAPH_TYPES.BUBBLE_CHART],
          defaultGraph: ANALYTICS_GRAPH_TYPES.BUBBLE_CHART,
          defaultSize: 'large',
          defaultVariant: 'data-forward',
          graphConfig: {
            [ANALYTICS_GRAPH_TYPES.BUBBLE_CHART]: {
              presentation: 'quadrant_scatter',
              xMetricId: 'daysOpen',
              yMetricId: 'pipelineDepth',
              bubbleMetricId: 'riskScore'
            }
          },
          dataSemantics: semantics(
            ANALYTICS_METRIC_SEMANTICS.RELATIONSHIP,
            ANALYTICS_TIME_BEHAVIORS.ROLLING_WINDOW,
            ANALYTICS_SUMMARY_BEHAVIORS.WINDOW_TOTAL
          ),
          supportedFilters: SCREEN_FILTERS,
          dataShape: {
            dimensions: ['requisition'],
            measures: ['days_open', 'pipeline_depth', 'progressed_candidates', 'stalled_candidates', 'known_losses', 'risk_score']
          }
        }),
        createAnalyticsLibraryEntry({
          id: 'stage_bottleneck',
          label: 'Stage Bottleneck',
          category: 'pipeline_risk_core',
          visualType: ANALYTICS_VISUAL_TYPES.MATRIX,
          supportedGraphs: [ANALYTICS_GRAPH_TYPES.HEATMAP],
          defaultGraph: ANALYTICS_GRAPH_TYPES.HEATMAP,
          defaultSize: 'medium',
          dataSemantics: semantics(
            ANALYTICS_METRIC_SEMANTICS.DURATION,
            ANALYTICS_TIME_BEHAVIORS.ROLLING_WINDOW,
            ANALYTICS_SUMMARY_BEHAVIORS.AVG_DURATION
          ),
          supportedFilters: SCREEN_FILTERS,
          supportsGroupBy: true,
          defaultGroupBy: ANALYTICS_GROUP_BY_KEYS.ROLE,
          groupByOptions: [
            ANALYTICS_GROUP_BY_KEYS.ROLE,
            ANALYTICS_GROUP_BY_KEYS.DEPARTMENT,
            ANALYTICS_GROUP_BY_KEYS.RECRUITER,
            ANALYTICS_GROUP_BY_KEYS.TAG,
            ANALYTICS_GROUP_BY_KEYS.LOCATION
          ],
          dataShape: {
            dimensions: ['stage', 'role'],
            measures: ['average_days_in_stage']
          }
        }),
        createAnalyticsLibraryEntry({
          id: 'vacancy_forecast',
          label: 'Vacancy Forecast',
          category: 'pipeline_risk_core',
          visualType: ANALYTICS_VISUAL_TYPES.TIME_SERIES,
          supportedGraphs: [ANALYTICS_GRAPH_TYPES.GANTT_TIMELINE],
          defaultGraph: ANALYTICS_GRAPH_TYPES.GANTT_TIMELINE,
          defaultSize: 'large',
          dataSemantics: semantics(
            ANALYTICS_METRIC_SEMANTICS.DURATION,
            ANALYTICS_TIME_BEHAVIORS.PERIOD_TREND,
            ANALYTICS_SUMMARY_BEHAVIORS.AVG_DURATION
          ),
          supportedFilters: SCREEN_FILTERS,
          dataShape: {
            dimensions: ['requisition', 'date'],
            measures: ['predicted_fill_date', 'target_start_date', 'confidence_range']
          }
        }),
        createAnalyticsLibraryEntry({
          id: 'offer_stalling',
          label: 'Offer Stalling',
          category: 'pipeline_risk_core',
          visualType: ANALYTICS_VISUAL_TYPES.PROGRESS,
          supportedGraphs: [ANALYTICS_GRAPH_TYPES.STALLING_OFFERS],
          defaultGraph: ANALYTICS_GRAPH_TYPES.STALLING_OFFERS,
          defaultSize: 'medium',
          dataSemantics: semantics(
            ANALYTICS_METRIC_SEMANTICS.COUNT,
            ANALYTICS_TIME_BEHAVIORS.NONE,
            ANALYTICS_SUMMARY_BEHAVIORS.WINDOW_TOTAL
          ),
          supportedFilters: SCREEN_FILTERS,
          dataShape: {
            dimensions: ['offer_state', 'offer'],
            measures: ['days_in_state', 'offer_count']
          }
        }),
        createAnalyticsLibraryEntry({
          id: 'candidate_dropoff_risk',
          label: 'Candidate Drop-off Risk',
          category: 'pipeline_risk_core',
          visualType: ANALYTICS_VISUAL_TYPES.TABLE,
          supportedGraphs: [ANALYTICS_GRAPH_TYPES.RISK_ACTION_TABLE],
          defaultGraph: ANALYTICS_GRAPH_TYPES.RISK_ACTION_TABLE,
          defaultSize: 'large',
          dataSemantics: semantics(
            ANALYTICS_METRIC_SEMANTICS.RATE,
            ANALYTICS_TIME_BEHAVIORS.ROLLING_WINDOW,
            ANALYTICS_SUMMARY_BEHAVIORS.CURRENT_RATE,
            ANALYTICS_DELTA_BEHAVIORS.MOM
          ),
          supportedFilters: SCREEN_FILTERS,
          dataShape: {
            dimensions: ['candidate', 'role', 'stage'],
            measures: ['risk_score', 'days_in_stage']
          }
        })
      ]
    })
  ]
});

export default pipelineRiskAnalyticsLibrary;
